<div class="container my-3">
    <h1 class="mb-3">Edit Conductivity Profile</h1>
    <form #form="ngForm" (ngSubmit)="updateConductivityprofile()">
      <!-- <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="name" class="form-label">Plant:</label>
        </div>
        <div class="col-sm-4">
          <select
            class="form-select border border-dark"
            name="plantid"
            (change)="getSelectedId($event)"
          >
            <option
              *ngFor="let plant of plants"
              [value]="plant.Id"
              [selected]="plant.Id === trainDetails.PlantId"
            >
              {{ plant.Name }}
            </option>
          </select>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="train" class="form-label">Train:</label>
        </div>
        <div class="col-sm-4">
          <select class="form-select border border-dark" name="trainid">
            <option *ngFor="let train of trains" [value]="train.Id"
            [selected]="train.Id === ListConductivityprofilesDetails.TrainId">
              {{ train.Name }}
            </option>
          </select>
        </div>
      </div> -->
  
      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="Datetime" class="form-label">Stage</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Datetime"
            name="Datetime"
            [(ngModel)]="ListConductivityprofilesDetails.Stage"
            disabled="true"
          />
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="PvId" class="form-label">Pressure Vessel ID</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="PvId"
            name="PvId"
            [(ngModel)]="ListConductivityprofilesDetails.PvId"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="PermCond" class="form-label">Permeate Conductivity</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="PermCond"
            name="PermCond"
            [(ngModel)]="ListConductivityprofilesDetails.PermCond"
          />
        </div>
      </div>
  
      
      <div style="min-height: 30px"></div>
      <div class="row">
        <div class="col-sm-2" style="text-align: right">
          <button type="submit" class="btn custom-buttons-btn mt-3">Submit</button>
        </div>
        <div class="col-sm-2" style="text-align: left">
          <button type="button" (click)="deleteConductivityprofile(ListConductivityprofilesDetails.Id)" class="btn custom-delete-btn mt-3">Delete</button>
        </div>
      </div>
    </form>
  </div>
